import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { FAILURE_SERVICE_COMPLAINTS, REQUEST_SERVICE_COMPLAINTS, SUCCESS_SERVICE_COMPLAINTS } from './actions';

export function serviceComplaintsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SERVICE_COMPLAINTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SERVICE_COMPLAINTS:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case FAILURE_SERVICE_COMPLAINTS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
